/**
 *
 * Asynchronously loads the component for MarketplacePage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./RecommendedReadingPage'));
